import { isNotNullOrUndefinedOrEmpty } from '../utility/string';

export class UnimplementedException extends Error {
  public readonly description: string;

  constructor(methodName?: string) {
    const description = isNotNullOrUndefinedOrEmpty(methodName) ?
      `Method [${methodName}] is not yet implemented.`:
      `Method is not yet implemented.`;

    super(description);
    this.description = description;
  }

  toString(): string {
    return `UnimplementedException: ${this.description}`;
  }
}
